import { QuestionBase } from './question-base';

export class MultiselectQuestion extends QuestionBase<string> {
  controlType = 'multiselect';
}